<template>
  <div class="paginating-container pagination-solid flex-column align-items-center mt-3">
    <ul role="menubar" class="pagination b-pagination">
      <template v-for="item in listPagination">
        <li role="presentation" class="page-item" :class="{ 'active': item.active }">
          <button role="menuitemradio" type="button" class="page-link" :disabled="item.disabled"
            @click="setPaging(item.value)">
            {{ item.value }}
          </button>
        </li>
      </template>

    </ul>
  </div>
</template>

<script setup>
import { defineProps, ref, defineEmits } from 'vue';
const props = defineProps(['pagination']);
const emit = defineEmits(['get-paging']);

// pagination
const makePagination = () => {
  let showPage = null;
  for (let item = 1; item <= countPage.value; item++) {
    if (((item >= currentPage.value - 2) && (item <= currentPage.value + 2)) || (item == 1) || (item == countPage.value)) {
      if ((showPage == 1) && (item != 2)) {
        listPagination.value.push({
          value: '...',
          active: false,
          disabled: true
        });
      }

      if (showPage != (countPage.value - 1) && (item == countPage.value) && (totalData.value > perPage.value)) {
        listPagination.value.push({
          value: '...',
          active: false,
          disabled: true
        });
      }

      if (item == currentPage.value) {
        listPagination.value.push({
          value: item,
          active: true
        });
      } else {
        listPagination.value.push({
          value: item,
          active: false
        });
      }
      showPage = item;
    }
  }
};

const totalData = ref(props.pagination.total);
const perPage = ref(props.pagination.per_page);
const countPage = ref(Math.ceil(props.pagination.total / props.pagination.per_page));
const currentPage = ref(props.pagination.current_page);
const listPagination = ref([]);
makePagination();

const setPaging = (page) => {
  emit('get-paging', page);
}

</script>